// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionTitle_root__M_xkw","title":"SectionTitle_title__1V5KX"};